// chinese
const zh = {
    // 通用
    query: '查询',
    examine: '审核',
    btnText: '登录',
    pleaseInput: '请输入',
    pleaseChoose: '请选择',
    longTermValid: '我的证件有效期是长期',
    submit: '提交',
    chooseDateTitle: '选择日期',
    confirm: '确定',
    close: '关闭',
    longTerm: '长期',

    //企业认证
    enterpriseTitle: '企业认证',
    clickUpload: '点击上传',
    businessLicenseInstru: '请按照图例，上传营业执照',
    companyName: '公司名称',
    enterpriseTaxNo: '企业税号',
    licenseNo: '营业执照号',
    licenseValidDate: '营业有效期',
    businessRegistrationInstru: '请按照图例，上传商户登记证',
    bizRegistrationNo: '商户登记证',
    legalPersonName: '法人姓名',
    legalPersonLastName: '法人姓',
    legalPersonCardNo: '法人证件号',
    legalPersonTaxNo: '法人税号',
    legalPersonInstru: '请按照图例，上传法人身份证件正面',
    legalPersonInstruNegative: '请按照图例，上传法人身份证件反面',
    signedPersonInstru: '请按照图例，上传签字人身份证件正面',
    signedPersonInstruNegative: '请按照图例，上传签字人身份证件反面',
    signedPersonTaxNo: '签字人税号',
    signName:'签字人姓名',
    signNamePlaceholder: '请输入签字人姓名',
    signCardNo:'签字人证件号',
    signCardNoPlaceholder: '请输入签字人证件号',
    signPerson: '签字人',
    legalPerson: '法人',
    bizRegistration: '商户登记证',
    bizLicense: '营业执照',
    enterpriseInfo:'企业信息',

    //企业认证placeholder
    enterpriseTaxNoPlaceholder: '请输入企业税号',
    companyNamePlaceholder: '请输入正确的公司名称',
    licenseNoPlaceholder: '请输入营业执照号',
    licenseValidDatePlaceholder: '请选择营业有效期',
    legalPersonNamePlaceholder: '请输入法人的姓名',
    legalPersonLastNamePlaceholder: '请输入法人的姓',
    legalPersonCardNoPlaceholder: '请输入法人证件号',
    legalPersonTaxNoPlaceholder: '请输入法人税号',
    signedPersonTaxNoPlaceholder: '请输入签字人税号',
    bizRegistrationNoPlaceholder:'请输入登记证号',

    //结果页
    submited: '已提交！',
    resultTitle: '结果',
    notVerify: '未认证',
    waitingAudit: '待审核',
    success: '认证成功',
    failed: '认证失败',
    gotoVerify: '重新认证',

    //商家二维码
    principleDetail:"规则明细",
    download:"下载",
    obtainAppFree:"立即免费获取应用",
    paypayProfile:"paypay，专业的支付平台，助力无现金生活场景。请从Android Play商店和Apple应用商店中下载。",
    paypayInstru:"商家二维码是paypay授权第三方商户使用的收款服务载体之一。方便商户收取费用，并可以通过paypay平台管理自己的账户，达到无现金状态。此二维码功能和维护权限归paypay所有，使用权归授权商户所有。另外，绑定二维码之后产生的交易记录，从绑定二维码时间开始算，既往记录不可查，解绑后，交易记录则不可查询，重新绑定也无法查询既往记录，请谨慎解绑。具体使用步骤如下：",
    bindQrCode:"绑定二维码",
    unbindQrCode:"解绑二维码",
    searchTransactionRecord:"查询交易记录",

    //帮助
    registration: '注册',
    realName: '实名',
    bindCard: '绑卡',
    recharge: '充值',
    transfer: '转账',
    withdrawl: '提现',
    registrationContent: '<p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><strong><span style="font-size:12ptpx">如何注册?</span></strong></p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"> </p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><strong>个人：</strong></p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">1. 打开paypay后，首页右上角点击【注册】按钮，进入个人用户注册流程。</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">2. 在选择用户类型的界面选择第一个【个人账户】，点击【下一步】按钮。</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">3. 注册帐号页面，输入手机号和短信验证码。另外，手机号要求输入9位数字。</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">4. 设置密码页面，您需要设置登录密码并重复登录密码，并点击【完成】按钮。登录密码要求：8-16位数字+字母组合。</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">5. 之后您会看到注册成功的页面</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"> </p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><strong>企业：</strong></p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">1. 打开paypay后，首页右上角点击【注册】按钮，进入企业用户注册流程。</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">2. 在选择用户类型的界面选择第二个【企业账户】，点击【下一步】按钮。</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">3. 注册帐号页面，输入邮箱和邮箱验证码。另外，<a href="mailto:邮箱要求按规范的邮箱格式xxx@xxx.xxx">邮箱要求按规范的邮箱格式xxx@xxx.xxx</a></p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">4. 设置密码页面，您需要设置登录密码并重复登录密码，并点击【完成】按钮。登录密码要求：8-16位数字+字母组合。</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">5. 之后您会看到注册成功的页面</p>',
    realNameContent: '<p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><strong><span style="font-size:12ptpx">如何实名?</span></strong></p><p></p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><strong><span style="font-size:12ptpx">个人：</span></strong></p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">1. 登陆成功后，Paypay首页回提示进行实名认证。点击【去实名】进入实名认证流程</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">2. 首先需要输入你的税号进行校验：输入完成后点击【NEXT】</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">3. 当你的税号校验通过后，页面上会显示你的名字片段，你需要把名（全名）补全，再点击【DONE]</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">4. 您会看到实名认证成功的页面.</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"> </p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><strong>企业：</strong></p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">1. 在注册成功后回到首页，输入注册的用户名和密码，点击【登录】按钮</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">2. 登录成功后，paypay首页会提示您去认证，点击【去认证】进入企业认证流程</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">3. 企业相关信息：公司名称、企业税号、营业执照号、营业有效期</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">4. 法人信息：商户登记证、法人姓名、法人证件号、法人税号，并上传法人证件号</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">5. 签字人相关信息：签字人姓名、签字人税号、签字人证件号</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">6. 商户登记相关信息：商户登记证</p>',
    bindCardContent: '<p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><strong><span style="font-size:12ptpx">如何绑卡?</span></strong></p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"> </p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">1. 点击【我的】-【银行卡】，进入银行卡绑定流程，并且在绑定银行卡页面点击【添加银行卡】按钮</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">2. 添加银行卡页面，您需要输入银行卡卡号，点击【下一步】验证银行卡信息；【支持的银行卡】可以查看支持哪些银行卡</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">3. 当您在输入银行卡后点击下一步，验证银行卡页面会自动获取持卡人的身份信息和银行卡信息，需要填写【银行卡预留手机号码】，并点击【发送验证码】，进行银行卡手机验证</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><span style="font-size:10.5ptpx">获取验证码后，输入验证码点击下一步，验证码校验通过后您绑卡就成功了</span></p>',
    rechargeContent: '<p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><strong><span style="font-size:12ptpx">如何充值?</span></strong></p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"> </p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">1. 若您已完成实名认证并设置完支付密码，您在登录Paypay首页点击【充值】按钮，就可以进入余额充值流程。然后在充值界面输入充值金额</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">2. 输入金额后，您需要选择需支付的卡，点击【支付】按钮。绑定银行卡的流程就如我们在第二部分里讲的，或者您也可以直接在这里点击添加银行卡去绑定</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">3. 选择完银行卡后，您需要输入支付密码，并且接受短信验证码。您需要保证支付密码和短信验证码都正确，然后点击【确认】按钮。</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">4. 通过以上操作您就充值成功了，这是充值成功的界面。充值成功后，您还可以去【我的】-【账户余额】里查看您的余额。</p>',
    transferContent: '<p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><strong><span style="font-size:12ptpx">如何转账?</span></strong></p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"> </p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">1. 若您已完成实名认证并设置完支付密码，您在登录Paypay首页点击【转账】按钮，就可以进入转账流程。</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">2. 您需要在右边这个页面输入您想转账的人的帐号，点击下一步后再输入您想要转账的金额，这样就可以开始转账</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">3. 输入金额后，您需要选择转账的支付方式，支付方式可以是余额也可以是您绑定的银行卡。需要注意的是只有储蓄卡才能进行转账。</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">4. 和充值相同的您也要输入支付密码。若您是选择银行卡方式支付，那么同样的您还是要输入手机验证码；若您是使用余额支付，那么您只要输入密码就转账成功了</p>',
    withdrawlContent: '<p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"><strong><span style="font-size:12ptpx">如何提现?</span></strong></p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false"> </p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">1. 若您的账户余额里有充足的钱，你想把账户里的钱转到银行卡，那么您就可以用到右图里【提现】这个功能。在首页点击【提现】后，进入提现流程</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">2. 您需要在提现的页面输入您想要提现的金额。请注意金额不能大于可用的余额，并且银行对每笔提现的金额也会有限制。</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">3. 输入金额后，您需要选择您想要提现到哪张银行卡。需要注意的是您只能提现到储蓄卡里。如果您不想提现到之前绑定银行卡里，您也可以在银行卡列表里添加新的银行卡进行提现。</p><p size="1" _root="[object Object]" __ownerID="undefined" __hash="undefined" __altered="false">4. 在选择完银行卡后，您在输入支付密码后，提现申请就成功了。需要注意的是体现的钱不一定能实时到达您的银行卡，这是由银行处理结果决定的，因此提现到账可能会有一定时间的延迟。</p>',
    slogan:"普惠 便捷",
    privatePolicy:"隐私政策",
    serviceAgreement:"服务协议",
    openPaypay:"打开PAYPAY",
    downloadPaypay:"下载PAYPAY",

    companyShortName:"公司简称",
    basicInfo:"基本信息",
    copies:"影印件",
    companyShortNameRequired:"请输入公司简称",
    phoneNumber:"联系电话",
    phoneNumberRequired:"请输入联系电话",
    emailRequired:"请输入Email",
    companyAddress:"公司地址",
    companyAddressRequired:"请输入公司地址",
    areaOfBusiness:"行业",
    bizAreaRequired:"请选择所属行业",
    companyNifPicInstru:"请按照图例,上传您的企业NIF照片",
    personalIdPicInstru:"请按照图例,上传您的ID正面照片",
    personalIdBackPicInstru:"请按照图例,上传您的ID反面照片",
    commercialCertPicInstru:"请按照图例,上传您的商户登记证照片或pdf文件",
    commercialCertPicInstruPdf:"请按照图例,上传您的商户登记证(Pdf文件)",

    //商户列表
    merchantListTitle:"商户列表",
    staffListTitle:"员工管理",
    staffDetailTitle:"员工详情",
    reject:'拒绝',
    agree:'同意',
    deleted:'已删除',
    all:'全部',
    today:'当日',
    latestWeek:'近一周',
    latestMonth:'近一个月',
    diyDate:'自定义',
    totalRevenue:'总收入',
    count:'笔',
    refund:'退款',
    fee:'费用',
    chooseClerk:'选择员工',
    clerk:'员工',
    clerkInputPlaceholder:'输入员工名称',
    addClerk:'添加员工',
    addStaffTitle:"用PayPay扫一扫，成为员工",
    clerkList:'员工列表',
    qrcodeRefreshTime:"二维码每两分钟自动刷新",
    sts:'状态',
    qrCode:"二维码编号",
    phoneNumber:"手机号",
    name:"姓名",
    del:"删除",
    contactMethod:"联系方式",
    addSuccess:"添加成功",
    normal:"正常",
    statisticalAnalysis:"收入分析",
    qrcodeScanInstru:"注:请将PayPay升级成最新版本",

    pdfFile:"Pdf文件",
    picture:"照片",
    realNameVerify:'实名认证',
    gender:"性别",
    birthday:"生日",
    province:'省份',
    city:'城市',
    personNIF:'NIF',
    next:'下一步',
    provincePlaceholder:'省份必选',
    cityPlaceholder:'城市必选',

    num:'编号',
    tradeVoucherNo:'消费凭证号',
    abnormal:'异常',
    refundSuccessForCashback:'返现退款成功',
    refundFailedForCashback:'返现退款失败',
    refundAbnormalForCashback:'返现退款异常',
    cashbackPolicyId:'返现策略ID',
    refundVoucherNo:'关联退款号',
    consumerAmount:'消费金额',
    cashbackAmount:'返现金额',
    contributeAccountNo:'出资账号',
    benefitedMemberId:'受益方会员ID',
    benefitedAccountNo:'受益方账户',
    transactionNo:'事务号',
    refundTransactionNo:'退款事务号',
    strategyName:'策略名称',
    benefitedPartyRole:'受益方角色',
    cashbackRatio:'返现比例',
    cashbackAmountRange:'返现金额范围',
    minPaymentAmount:'起付金额',
    statisticsDetail:'统计字段',
    benefitedStatisticsAmountLimit:'受益方返现金额限值',
    benefitedStatisticsCountLimit:'受益方返次数额限值',
    bizStatisticsAmountLimit:'业务累计返现金额',
    bizStatisticsCountLimit:'业务累计返现次数',
    specificMember:'特定会员',
    cashbackWithRatio:'按交易金额比例返现',
    cashbackWithRandom:'随机返现',
    day:'日',
    minCashbackAmount:'最小返现额',
    maxCashbackAmount:'最大返现额',
    cashbackDetail:'返现详情',
    cashbackReason:'返现原因',
    createTime: '创建时间',
    sts: '状态',
    cashbackRecord:'返现',
    cashbackAnouncement:'返现公告',
    cashbackTotalAmount:'已返现总额',
    displayName:'显示名称',
    modifyDisName:'修改显示名称',
    displayNameRequired:'显示名称不能为空',
    
    //消费立减
    reductionType:'立减类型',
    randomReduction:'随机立减',
    deductionReduction:'抵扣立减',
    reductionStretegy:'立减策略',
    startAmount:'起付线',
    reductionRange:'立减金额范围',
    minReductionAmount:'最小立减额',
    maxReductionAmount:'最大立减额',
    statisticsType:'统计类型',
    noLimit:'不限制',
    personalAccumulationAmount:'按个人累积金额',
    personalAccumulationCount:'按个人累积笔数',
    personalAndBizAccumulationAmount:'按个人和业务累积金额',
    personalAndBizAccumulationCount:'按个人和业务累积笔数',
    accumulationLimit:'累积限定值',
    accumulationActivityLimit:'累积活动限定值',
    reductionRatio:'立减比例',
    tradeDirection:'交易方向',
    revenue:'收入',
    expenditure:'支出',
    tradeNo:'交易号',
    reductionType:'类型',
    amountBeforeTrade:'交易前余额',
    amountAfterTrade:'交易后余额',
    fundDetail:'资金明细',
    txnTradeAmount:'关联交易金额',
    txnTradeProductDesc:'关联商品',
    txnTradeSellerName:'关联卖家',
    txnTradeCreate:'交易时间',
    balance:'余额',
    txnTradeVoucherNo:'关联交易凭证号',
    txnTradeGmtCreate:'关联交易时间',
    tradeAmount:'交易金额',
    availableBalance:'可用余额: ',
    freezeBalance:'冻结余额:',
    historyCashback:'历史返现总额: ',
    biz_purpose: "商业目的",

    input_his_account: "请输入对方手机",
    wait_handle: "待处理列表",
    send: '发送',
    sent: '已发送',
    sendAll: '全部发送',
    noDataSend: '没有记录发送',
    manualInvite: '手动邀请',
    qrcodeInvite: '二维码邀请',
    inviteTips: '{0}邀请你成为他的店员，同意后你将协助他收款，是否同意？',
    addStaffTitle2: '输入用户手机或邮箱, 邀请用户',
    isExists: '已经存在',
    addTooMuch: "发送过多",

    please_select_store: '请选择店铺',
    all_store: '全部店铺',
    all_staff: '全部店员',
    store: '店铺',
    other_store: '无门店',
    no_staff: '没有员工',
    you_can_not_change_store: "该店员已分配了店铺, 无法修改.",
    are_you_sure: "确定操作?",

    work_day: '经营时间',
    work_day_all: '周一～周日',
    work_day_a: '周一～周五',
    work_day_1: "周一",
    work_day_2: "周二",
    work_day_3: "周三",
    work_day_4: "周四",
    work_day_5: "周五",
    work_day_6: "周六",
    work_day_7: "周日",
    store_address: "店铺地址",
    store_desc: '店铺描述',
    store_group: "团购套餐",
    available_date: "有效期至",
    unlimited_date: "长期",
    share_store: '店铺分享',
    open_with_paypay: '使用PayPay打开',
    open_tips: '使用PayPay支付更方便',
    opening: '正在打开PayPay...',
    open_fail: '打开PayPay失败',
    open_fail_tips: '你还没有安装PayPay，是否前去下载',
    coupon_type_1: "全场减{0}",
    coupon_type_2: "满{0}减{1}",
    coupon_type_4: "减{0}%",
    share_group: "分享团购",
    group_content: "套餐内容",
    target_user_1: '全体用户可用',
    target_user_2: '新用户可用',
    target_user_3: '老用户可用',
    claim_with_paypay: '打开PayPay领取优惠券',
    wechat_open_tips: "微信里无法打开app，你可以点击微信这里的三颗点(...)，使用系统默认浏览器打开，再重试",
    share_error_tips: "抱歉，用户分享的信息已失效。",
    auto_coupon_txt: "消费满{0}KZ({1}),赠送一张优惠券'{2}'",
    auto_coupon_type_1: "折扣前",
    auto_coupon_type_2: "实付",
    share_coupon: "分享优惠券",
    share_paypay: "PayPay分享",
    clerk_order_permission: "允许店员查看全部收款记录",
    operate_success: "操作完成",
    operate_fail: "操作失败",
    my_order_analysis: "我的订单情况",

    lucky: '抽奖',
    winning_record: '获奖记录',
    no_active: '本期抽奖活动已结束',
    no_active_tips: '敬请期待下一次活动。',
    luckyCount: "可抽奖次数",
    winnerText: "恭喜用户 {0} 获得 {1}",
    no_prize: '无奖品',
    start: '开始抽奖',
    win_text: '恭喜你，获得: {0}',
    no_win_text: '很遗憾，没有获得奖品',
    no_luck_draw_count: '抽奖次数已用完',
    lucky_rule: '抽奖规则',
    rule_tips: "注：抽奖规则请往下看",
    lucky_product: '活动名称',
    lucky_product_rule: '抽奖规则',
    lucky_product_time: '活动时间',
    lucky_product_entry: '入口',
    lucky_users_tips: '此活动仅支持个人用户参加。',
    lucky_owner: '*此活动解释权归PayPay所有*',
    lucky_wait: '敬请期待',
    lucky_recharge: '请充值',
    lucky_buy: '请消费',
    lucky_has_end: '已结束',
    reward_tips: '奖品将在2小时内发放到您的返现账户，请注意查收。',
    no_reward: '已无记录',
    back_to: '继续抽奖',
    cashback_amount: '返现金额:{0} kz',
    wait_reward: '等待发放',
    reward_success: '发放成功',
    reward_fail: '返现发放',
    thankyou: '谢谢参与',

    cashbackTips: '返现余额可在商圈消费',

    winnerList: '获奖名单',
    expand: '展开',
    collapse: '收起',
    no_winner: '暂无获奖名单',
    view: '查看',
    winner_title: '中奖名单 (最近20条)'
}
export default zh;


// WEBPACK FOOTER //
// ./src/resource/zh.cn.js